// Musela byt do aplikace pridana externi d.ts definice i kdyz je to nativni soucasti TypeScript, tak pri kompilaci to hlasi chybu.
// https://tfs/Jadro/Jadro%20.NET/_workitems/edit/34074

declare interface ResizeObserver {
    observe(target: Element): void;
    unobserve(target: Element): void;
    disconnect(): void;
}

// eslint-disable-next-line no-var
declare var ResizeObserver: {
    prototype: ResizeObserver;
    new(callback: ResizeObserverCallback): ResizeObserver;
};

interface ResizeObserverSize {
    readonly blockSize: number;
    readonly inlineSize: number;
}

interface ResizeObserverCallback {
    (entries: ResizeObserverEntry[], observer: ResizeObserver): void;
}

interface ResizeObserverEntry {
    readonly borderBoxSize: ReadonlyArray<ResizeObserverSize>;
    readonly contentBoxSize: ReadonlyArray<ResizeObserverSize>;
    readonly contentRect: DOMRectReadOnly;
    readonly target: Element;
}
